import { render, staticRenderFns } from "./Naturalcolors.vue?vue&type=template&id=52f1dd68&scoped=true&"
import script from "./Naturalcolors.vue?vue&type=script&lang=js&"
export * from "./Naturalcolors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f1dd68",
  null
  
)

export default component.exports